module.exports = __webpack_public_path__ + "img/bg-th3.e07fa5ae.png";